// Dashboard that appears on top of the main screen showing tickets, issued,
// omitted, manually closed and traffic data.
import React from 'react';
import styles from '../css/topDashboard.module.css';
import { useEffect, useState } from 'react';
import {
  fetchTicketIssuedCount,
  fetchCheckOutsCount,
  fetchCheckOutsCountThisHour,
  fetchCheckInsCountThisHour,
  fetchAvgStayDuration,
  fetchOccupancyData,
  fetchManualCheckOutsCount,
  countUnCheckedInTickets,
} from '../helpers/databaseAPI';
import { getPendingCheckouts } from '../helpers/databaseFiles';
// import {
//   getCheckoutTicketData,
//   postCheckOut,
//   deleteTicketLocation,
//   showTicketInformation,
// } from '../helpers/databaseAPI';
import { serverURL } from '../helpers/dataServerURL';
// import { useNavigate } from 'react-router-dom';

function TopDashboard() {
  const loginURL = serverURL.server.url;

  const [ticketIssuedCount, setTicketIssuedCount] = useState(0);
  const [checkOutsCount, setCheckOutsCount] = useState(0);
  const [checkOutsCountThisHour, setCheckOutsCountThisHour] = useState(0);
  const [checkInsCountThisHour, setCheckInsCountThisHour] = useState(0);
  const [avgStayDuration, setAvgStayDuration] = useState({ hours: 0, minutes: 0 });
  const [manualCheckOutsCount, setManualCheckOutsCount] = useState(0);
  const [pendingCheckOuts, setPendingCheckOuts] = useState(null);
  const [omittedTicketsCount, setOmittedTicketsCount] = useState(0);
  const [occupancyData, setOccupancyData] = useState(null);
  // const [scannedTicket, setScannedTicket] = useState(null);
  // const [ticketNumber, setTicketNumber] = useState(null);
  // const [isTktFound, setIsTktFound] = useState(false);

  // const startRef = useRef(null);
  // const resultRef = useRef(null);
  // const legendRef = useRef(null);
  // const checkOutBtnRef = useRef(null);

  // const navigate = useNavigate();

  useEffect(() => {
    async function populateDashCards() {
      setTicketIssuedCount((await fetchTicketIssuedCount(loginURL)) || 0);
      setCheckOutsCount(await fetchCheckOutsCount(loginURL));
      setCheckOutsCountThisHour((await fetchCheckOutsCountThisHour(loginURL)) || 0);
      setCheckInsCountThisHour(fetchCheckInsCountThisHour(loginURL) || 0);
      setAvgStayDuration(await fetchAvgStayDuration(loginURL));
      setManualCheckOutsCount((await fetchManualCheckOutsCount(loginURL)) || 0);
      setPendingCheckOuts((await getPendingCheckouts(loginURL)) || 0);
      setOmittedTicketsCount((await countUnCheckedInTickets(loginURL)) || 0);
      setOccupancyData((await fetchOccupancyData(loginURL)) || 0);
    }
    populateDashCards();
  }, []);

  // useEffect(() => {
  //   function focusOnStart() {
  //     startRef.current.focus();
  //   }
  //   focusOnStart();
  // }, []);
  return (
    <div>
      <div className={styles.topContainer}>
        <h3>Activities Dashboard</h3>
        <div className={styles.secondaryContainer}>
          <div className={styles.card} style={{ backgroundColor: '#255cb6' }}>
            <h2>Tickets Issued</h2>
            <p>{ticketIssuedCount}</p>
          </div>
          <div className={styles.card} style={{ backgroundColor: ' #22c55e' }}>
            <h2>Pending Check Outs</h2>
            <p>{pendingCheckOuts}</p>
          </div>
          <div className={styles.card} style={{ backgroundColor: '#a855f7' }}>
            <h2>Tickets Exited</h2>
            <p>{checkOutsCount}</p>
          </div>
          <div className={styles.card} style={{ backgroundColor: '#eab308' }}>
            <h2>Current Occupancy</h2>
            <p>{occupancyData}</p>
          </div>
          <div className={styles.card} style={{ backgroundColor: '#ef4444' }}>
            <h2>Average Stay</h2>
            <p>
              {avgStayDuration.hours} Hrs: {avgStayDuration.minutes} Min
            </p>
          </div>
          <div className={styles.card} style={{ backgroundColor: '#6366f1' }}>
            <h2>
              Cars Entered Between{' '}
              {new Date().getHours() > 12
                ? new Date().getHours() -
                  12 +
                  `P- 
                  ${new Date().getHours() - 12}:59P`
                : new Date().getHours() === 12
                  ? `12P-12:59P`
                  : `${new Date().getHours()}:00A - ${new Date().getHours()}:59A`}
            </h2>
            <p>{checkInsCountThisHour || 0}</p>
          </div>
          <div className={styles.card} style={{ backgroundColor: '#f3cc' }}>
            <h2>
              {' '}
              Cars Exited Between{' '}
              {new Date().getHours() > 12
                ? `${new Date().getHours() - 12}P-${new Date().getHours() - 12}:59P`
                : new Date().getHours() === 12
                  ? `12P-12:59P`
                  : `${new Date().getHours()}:00A - ${new Date().getHours()}:59A`}
            </h2>
            <p>{checkOutsCountThisHour}</p>
          </div>
          <div className={styles.card} style={{ backgroundColor: '#16a34a' }}>
            <h2>Manually Closed Tickets</h2>
            <p>{manualCheckOutsCount}</p>
          </div>
          <div className={styles.card} style={{ backgroundColor: '#eab308' }}>
            <h2>Tickets Not Scanned In</h2>
            <p>{omittedTicketsCount}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TopDashboard;
